const racism = `Racism is when people are treated badly because of their skin color, culture, or where they come from. 
Some people in Finland might face racism, and it's important to talk about it.
Many people in Finland are kind and treat everyone equally, no matter where they come from. 
They understand that everyone is different and that's okay. 
They believe in being fair and giving everyone a chance to show who they are.
In Finland, there are also some people who might think that people from other countres are taking their job and reducing opportunities for them.
Recession and unemployment and alcoholism can lead to hurtful thoughts.
Some people act unfair to people who are not of finnish orgin.
This is not good and can make them feel sad and hurt. 
Racism can make it hard for people to find jobs or make friends, and this is not fair.
Different people have different experiences about racism. 
They might have been treated badly or heard mean things because of who they are. 
This can be hard and make them feel alone. 
It's important for everyone to support each other and stand up against racism.
There are also people who never experience racism at all. 
We cannot generalize this and say that there is no racism in Finland.
In the future, it's important to keep talking about racism and how we can all be kind to each other. 
We can learn from each other and understand that everyone is special, no matter where they come from or what they look like. 
It's important to treat everyone with respect and kindness.`;

export default racism;